












exports.default =
  props:
    loading: {}
    size:
      default: '30px'

  computed:
    style: ->
      width: @size
      height: @size



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/loading.vue